<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento retroativo">
            <template v-slot:actions>
                <rkm-button
                    color="primary"
                    @click.stop="redirectToMainRecepcao"
                >
                    Paciente desconhecido
                </rkm-button>

                <rkm-button
                    v-if="isPermissaoCadastro"
                    color="primary"
                    @click.stop="showQuestion"
                >
                    Novo paciente
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List>
                    <template #actions="{ item }">
                        <rkm-button
                            color="primary"
                            class="align-self-end"
                            @click="redirectToMainRecepcao(item)"
                        >
                            Recepcionar
                        </rkm-button>
                    </template>
                </List>
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalPacienteCadastroSimplificado
            ref="ModalPacienteCadastroSimplificado"
            @save="redirectToMainRecepcao"
        />
    </rkm-overlay>
</template>

<script>
import List from '@/components/cadastro/paciente/components/busca/List'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

// Mixins.
import { repository, error, data } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { List, ModalPacienteCadastroSimplificado },
    created() {

        this.repositories = {
            dataHora: this.getConectaSusRepository('dataHora'),
            atendimentoRetroativo: this.getConectaSusRepository('prontoAtendimento.atendimentoRetroativo'),
        }

        this.load()
    },
    data: () => ({
        isPermissaoCadastro: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.atendimentoRetroativo.index()
                .then(({ data }) =>

                    this.isPermissaoCadastro = data.classificacoes.length > 0 || data.isPermissaoCadastro
                        ? true
                        : false
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        showQuestion() {

            this.showConfirmation('O paciente apresentou os documentos?',
                async () => this.$refs.ModalPacienteCadastroSimplificado.open(),
                async () => {

                    this.setLoading()

                    this.repositories.dataHora.get()
                        .then(({ data }) => this.$refs.ModalPacienteCadastroSimplificado
                            .openWithoutDocuments(this.getDateTimeObject(data)))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            )
        },
        redirectToMainRecepcao(paciente) {

            const params = {}

            if (paciente) {

                params.pacienteId = paciente.id
            }

            this.$router.push({ name: 'pronto-atendimento-atendimento-retroativo-create', params })
        },
    },
    mixins: [repository, error, data]
}
</script>